export default __webpack_public_path__ + "static/media/Mishka.a6bdda2f.jpg";